module.exports = __webpack_public_path__ + "static/WoodBox-e16a2311d69ae52a631d8bbd68cd1b46.jpg";